import { postRequest } from 'servos/apiRequests'
import currencyFormatter from '../../utils/currencyFormatter';
import formatPercentage from '../../utils/formatPercentage';

export const postSetupCost = (data, onSuccess, onFailure) => {
  let url = '/calculators/setup_costs.json'
  postRequest({ url, data, onSuccess, onFailure })
}

export const postBorrowAmount = (data, onSuccess, onFailure) => {
  let url = '/calculators/borrow_amount.json'
  postRequest({ url, data, onSuccess, onFailure })
}

export const postRefinance = (data, onSuccess, onFailure) => {
  let url = '/calculators/refinance.json'
  postRequest({ url, data, onSuccess, onFailure })
}

export const postMortgageRepayment = (data, onSuccess, onFailure) => {
  let url = '/calculators/mortgage_repayment_calc.json'
  postRequest({ url, data, onSuccess, onFailure })
}

export const postOffset = (data, onSuccess, onFailure) => {
  let url = '/calculators/offset.json'
  postRequest({ url, data, onSuccess, onFailure })
}

export const getComparisonRate = async (
  LoanAmount,
  Upfront,
  Ongoing,
  EndFees,
  rate,
  termOfLoan,
) => {
  const values = {
    ClientID: 'Yard',
    Token: gon.services.calculator_api_key,
    TestDomain: 'yard.com.au',
    CalcName: 'ComparisonRate',
    LoanAmount: currencyFormatter.format(LoanAmount),     //Loan Amount
    LoanTerm: `${termOfLoan} years`,       //Loan Term
    InterestRate: formatPercentage(rate,2),      //Standard Interest Rate
    IntroTerm: '12 months',     // Intro Term in months, NOT years
    IntroRate: formatPercentage(rate,2),         //Intro Interest Rate
    Upfront: currencyFormatter.format(Upfront),            //upfront fees
    Ongoing: currencyFormatter.format(Ongoing),             //Ongoing fees
    EndFees: currencyFormatter.format(EndFees),            //Ending fees
    FeeFrequency: '1'          //Onging Fee Frequency 1, 2, 4, 12 etc
  };

  try {
    const response = await fetch('https://www.visionabacus.net/API/Yard/comparisonrate/json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(values),
    });

    const data = response.json();

    return data;
  } catch (error) {
    console.error('An error occurred...', error);
  }
};

export const getStampDutyResult = async ({
  state,
  firstHomeBuyer,
  loanTarget,
  status,
  propertyPrice,
}) => {
  const purpose = loanTarget === 'own_home' ? 'residence' : 'investment'
  const firstHome = firstHomeBuyer ? 'YES' : 'NO'

  const values = {
    ClientID: 'Yard',
    Token: gon.services.calculator_api_key,
    TestDomain: 'yard.com.au',
    CalcName: 'StampDutyProperty',
    State: state.toUpperCase(),               //ACT, NSW, NT, QLD, TAS, SA, VIC WA
    Value: currencyFormatter.format(propertyPrice),            // number as string  
    Purpose: purpose,         // "residence", "investment"
    IsFirstHomeBuyer: firstHome,      //if yes, use 1 or true or "yes".  otherwise no
    Status: status,                  // 1 new 2 - established 3 land
    IsPensioner: 'no',            //if yes, use 1 or true or "yes".  otherwise no
    Income: '$80,000',            // number as string
    Ddependent: '0',              //number from 0 to 5
    IsForeigner: 'no',            //if yes, use 1 or true or "yes".  otherwise no
    PaymentMethod: '1'            //payment method 0 Paper Transaction  1 Electronic Transaction
  };

  try {
    const response = await fetch('https://www.visionabacus.net/API/Yard/stampduty/json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(values),
    });

    const data = response.json();
    return data;
  } catch (error) {
    console.error('An error occurred...', error);
  }
};
